/**
 * Wrapper for YouTubeIframe Api
 * Node Package @link https://www.npmjs.com/package/vue-youtube
 * API @link https://developers.google.com/youtube/iframe_api_reference#Events
 */
import YouTube from "vue3-youtube";
import getIdFromUrl from "get-youtube-id";
import EventBus from "@plugins/common/service/eventbus";

const VueYoutubePlugin = {
  install(app) {
    app.component("YouTube", YouTube);

    this.eventBus = new EventBus();
    this.getIdFromUrl = getIdFromUrl;

    /**
     * Plugin API
     */
    if (!app.config.globalProperties.$youtube) {
      app.config.globalProperties.$youtube = {};
    }

    app.config.globalProperties.$youtube.pauseAll = () => {
      VueYoutubePlugin.eventBus.$emit("pause-all");
    };

    app.config.globalProperties.$youtube.destoryAll = () => {
      VueYoutubePlugin.eventBus.$emit("destroy-all");
    };
  },
};
export default VueYoutubePlugin;
